/** Planned attendance, its exceptions and linked execution use the same vocabulary everywhere. */
import { VisitBrowseRow, VisitBrowseState, VisitDisplayStatus, visitDisplayStatus } from '@jms/model';
import { defineConditionalTag } from '../../shared/define.conditional.tag';
import type { StatusTone } from '../../shared/status.tag.tones';

const TONES: Record<VisitDisplayStatus, StatusTone> = {
  [VisitDisplayStatus.Planned]: 'neutral',
  [VisitDisplayStatus.Modified]: 'brand',
  [VisitDisplayStatus.Rescheduled]: 'brand',
  [VisitDisplayStatus.Skipped]: 'neutral',
  // A Job exists and is still Open: brand matches the Job board's own Open/Scheduled tone.
  [VisitDisplayStatus.Scheduled]: 'brand',
  [VisitDisplayStatus.InProgress]: 'warning',
  [VisitDisplayStatus.OnHold]: 'warning',
  [VisitDisplayStatus.Completed]: 'success',
  [VisitDisplayStatus.Cancelled]: 'neutral',
};

export const visitStateTag = defineConditionalTag<VisitBrowseRow>(row => {
  const label = visitDisplayStatus(row);
  return { label, tone: TONES[label] };
});

// InProgress and OnHold are the only raw VisitStatus values that print differently from their
// display label ('In progress', 'On hold'); the rest already match their VisitDisplayStatus string.
const STATUS_LABELS: Partial<Record<string, VisitDisplayStatus>> = {
  InProgress: VisitDisplayStatus.InProgress,
  OnHold: VisitDisplayStatus.OnHold,
};

/** A Job can add execution status; otherwise the primary Visit pill already names the lifecycle. */
export const visitStatusTag = defineConditionalTag<VisitBrowseRow>(row => {
  if (!row.job?._id || !row.status || row.status === 'Scheduled' || row.status === VisitBrowseState.Projected) return null;
  const label = STATUS_LABELS[row.status] ?? row.status;
  return { label, tone: TONES[label as VisitDisplayStatus] ?? 'neutral' };
});
